<template>
  <div id="bottom-button">
    <div class="wrapper">
      <button class="button button1" :class="{ active: state, inactive: !state }"
        @click="bottomClick(0)">{{title1}}</button>
      <button class="button button2" :class="{ active: state, inactive: !state }"
        @click="bottomClick(1)">{{title2}}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title1: '',
    title2: '',
    state: 0
  },
  data () {
    return {
      aaa: ''
    }
  },
  methods: {
    bottomClick: function (index) {
      this.$emit('click', index)
    }
  }
}
</script>

<style scoped>
.wrapper {
  position: fixed;
  width: 100%;
  bottom: 0px;
  height: 65px;
  background-color: #ffffff;
  border-top: solid #eeeeee 1px;
  box-sizing: border-box;
  z-index: 100;
}
.wrapper .button {
  position: absolute;
  top: 10px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 15px;
  width: calc(50% - 25px);
  color: #ffffff;
  border-radius: 3px;
}
.wrapper .button1 {
  position: absolute;
  left: 15px;
  top: 10px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 15px;
  color: #ffffff;
  border-radius: 3px;
}
.wrapper .button2 {
  position: absolute;
  right: 15px;
  top: 10px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 15px;
  color: #ffffff;
  border-radius: 3px;
}
.inactive {
  background-color: #fe9797;
}
.active {
  background-color: #c41335;
}
</style>



// WEBPACK FOOTER //
// src/components/bottom-button2.vue